import VerticalScrollWrapper from './VerticalScrollWrapper'

export default VerticalScrollWrapper
